<template>
<Header>
    <Menu mode="horizontal" theme="dark" :active-name="selectMenu" class="my-menu" >
        <Row type="flex" class="menu-row" >
            <Col flex="auto" class="menu-container flex-left">
            <div class="logo-container">
            <router-link to="/dashboard" class="flex-middle">
                <img :src="require('@/assets/img/logo.png')" class="logo" />
            </router-link>
            </div>
            <MenuItem name="1-1" :to="{ name: 'dashboard' }" :class="['menu-item', selectMenu == '1-1' ? 'active-menu-item' : '']">
            <img :src="selectMenu == '1-1' ? require('@/assets/img/menu-icons-1-1-active.png') : require('@/assets/img/menu-icons-1-1-normal.png')" class="menu" />
            <div class="menu-text">{{ getTranslation("l001") }}</div>
            </MenuItem>
            <MenuItem name="2-1" :to="{ name: 'productline' }" v-show="canShow('productline.view')" :class="['menu-item', selectMenu == '2-1' ? 'active-menu-item' : '']">
            <img :src="selectMenu == '2-1' ? require('@/assets/img/menu-icons-2-1-active.png') : require('@/assets/img/menu-icons-2-1-normal.png')" class="menu" />
            <div class="menu-text">{{ getTranslation("u045") }}</div>
            </MenuItem>
            <MenuItem name="3-1" :to="{ name: 'machine' }" :class="['menu-item', selectMenu == '3-1' ? 'active-menu-item' : '']" v-show="canShow('machine.view')">
            <img :src="selectMenu == '3-1' ? require('@/assets/img/menu-icons-3-1-active.png') : require('@/assets/img/menu-icons-3-1-normal.png')" class="menu" />
            <div class="menu-text">{{ getTranslation("u048") }}</div>
            </MenuItem>

            <MenuItem name="sys" ref="userMenu" :class="['menu-item', (isUserActive || showUserMenu) ? 'active-menu-item' : '']" @mouseenter.native="openSystemMenu('showUserMenu')" @mouseleave.native="maybeCloseSystemMenu('showUserMenu')">
            <div class="sub-menu-item">
                <img :src="(isUserActive || showUserMenu) ? require('@/assets/img/menu-icons-4-1-active.png') : require('@/assets/img/menu-icons-4-1-normal.png')" class="menu" />
                <div class="menu-text">{{ getTranslation("u051") }}</div>
                <Icon type="ios-arrow-down" :color="(isUserActive || showUserMenu) ? '#5bb7ff' : '#ffffff'" :class="['dropdown-arrow', { open: showUserMenu }]" />
            </div>
            <div class="sub-menu-content" v-show="showUserMenu" @mouseenter="onDropdownEnter('showUserMenu')" @mouseleave="onDropdownLeave('showUserMenu')">
                <MenuItem name="4-1" :to="{ name: 'user' }" v-show="canShow('user.view')" :class="['menu-item', selectMenu == '4-1' ? 'active-menu-item' : '']">
                <img :src="selectMenu == '4-1' ? require('@/assets/img/menu-icons-4-1-active.png') : require('@/assets/img/menu-icons-4-1-normal.png')" class="menu" />
                <div class="sub-menu-text">{{ getTranslation("u051") }}</div>
                </MenuItem>
                <MenuItem name="12-1" :to="{ name: 'user-modify_password' }" :class="['menu-item', selectMenu == '12-1' ? 'active-menu-item' : '']">
                <Icon type="ios-lock-outline" :color="selectMenu == '12-1' ? '#5bb7ff' : '#ffffff'" />
                <div class="icon-menu-text">{{ getTranslation("u105") }}</div>
                </MenuItem>
                <MenuItem name="8-1" :to="{ name: 'role' }" v-show="canShow('role.view')" :class="['menu-item', selectMenu == '8-1' ? 'active-menu-item' : '']">
                <img :src="selectMenu == '8-1' ? require('@/assets/img/menu-icons-8-1-active.png') : require('@/assets/img/menu-icons-8-1-normal.png')" class="menu" />
                <div class="sub-menu-text">{{ getTranslation("u004") }}</div>
                </MenuItem>
            </div>
            </MenuItem>
            <MenuItem name="funcs" ref="func" :class="['menu-item', (isFuncActive || showFuncMenu) ? 'active-menu-item' : '']"  @mouseenter.native="openSystemMenu('showFuncMenu')" @mouseleave.native="maybeCloseSystemMenu('showFuncMenu')">
            <div class="sub-menu-item">
                <Icon type="ios-hammer-outline" :color="isFuncActive  || showFuncMenu ? '#5bb7ff' : '#ffffff'" />
                <div class="menu-text">{{ getTranslation("b222") }}</div>
                <Icon type="ios-arrow-down" :color="(isFuncActive || showFuncMenu) ? '#5bb7ff' : '#ffffff'" :class="['dropdown-arrow', { open: showFuncMenu }]" />

                <div class="sub-menu-content" v-show="showFuncMenu" @mouseenter="onDropdownEnter('showFuncMenu')" @mouseleave="onDropdownLeave('showFuncMenu')">
                    <MenuItem name="5-1" :to="{ name: 'library' }" v-show="canShow('library.view')" :class="['menu-item', selectMenu == '5-1' ? 'active-menu-item' : '']">
                    <img :src="selectMenu == '5-1' ? require('@/assets/img/menu-icons-5-1-active.png') : require('@/assets/img/menu-icons-5-1-normal.png')" class="menu" />
                    <div class="sub-menu-text">{{ getTranslation("p089") }}</div>
                    </MenuItem>
                    <MenuItem name="21-1" :to="{ name: 'expulsion' }" v-show="canShow('expulsion.view')" :class="['menu-item', selectMenu == '21-1' ? 'active-menu-item' : '']">
                    <Icon type="ios-stats-outline" :color="selectMenu == '21-1' ? '#5bb7ff' : '#ffffff'" />
                    <div class="icon-menu-text">{{ getTranslation("e001") }}</div>
                    </MenuItem>
                    <MenuItem name="22-1" :to="{ name: 'fixalarm' }" v-show="canShow('fixAlarm.view')" :class="['menu-item', selectMenu == '22-1' ? 'active-menu-item' : '']">
                    <Icon type="ios-warning-outline" :color="selectMenu == '22-1' ? '#5bb7ff' : '#ffffff'" />
                    <div class="icon-menu-text">{{ getTranslation("p050") }}</div>
                    </MenuItem>
                    <MenuItem name="23-1" :to="{ name: 'browser' }"  :class="['menu-item', selectMenu == '23-1' ? 'active-menu-item' : '']">
                    <Icon type="md-barcode" :color="selectMenu == '23-1' ? '#5bb7ff' : '#ffffff'" />
                    <div class="icon-menu-text">{{ getTranslation("e042") }}</div>
                    </MenuItem>
                </div>
            </div>
            </MenuItem>

            <MenuItem name="sys" ref="systemMenu" v-show="canShow('history.view') || canShow('init.view') || canShow('setting.view')" :class="['menu-item', (isSystemActive || showSystemMenu) ? 'active-menu-item' : '']" @mouseenter.native="openSystemMenu('showSystemMenu')" @mouseleave.native="maybeCloseSystemMenu('showSystemMenu')">
            <div class="sub-menu-item">
                <Icon type="ios-settings" :color="(isSystemActive || showSystemMenu) ? '#5bb7ff' : '#ffffff'" class="menu" />
                <div class="menu-text">{{ getTranslation("c026") }}</div>
                <Icon type="ios-arrow-down" :color="(isSystemActive || showSystemMenu) ? '#5bb7ff' : '#ffffff'" :class="['dropdown-arrow', { open: showSystemMenu }]" />
            </div>
            <div class="sub-menu-content" v-show="showSystemMenu" @mouseenter="onDropdownEnter('showSystemMenu')" @mouseleave="onDropdownLeave('showSystemMenu')">
                <MenuItem name="6-1" :to="{ name: 'history' }" v-show="canShow('history.view')" :class="['menu-item', selectMenu == '6-1' ? 'active-menu-item' : '']">
                <img :src="selectMenu == '6-1' ? require('@/assets/img/menu-icons-6-1-active.png') : require('@/assets/img/menu-icons-6-1-normal.png')" class="menu" />
                <div class="sub-menu-text">{{ getTranslation("s001") }}</div>
                </MenuItem>
                <MenuItem name="7-1" :to="{ name: 'init' }" v-show="canShow('init.view')" :class="['menu-item', selectMenu == '7-1' ? 'active-menu-item' : '']">
                <img :src="selectMenu == '7-1' ? require('@/assets/img/menu-icons-7-1-active.png') : require('@/assets/img/menu-icons-7-1-normal.png')" class="menu" />
                <div class="sub-menu-text">{{ getTranslation("i001") }}</div>
                </MenuItem>
                <MenuItem name="10-1" :to="{ name: 'setting' }" v-show="canShow('setting.view')" :class="['menu-item', selectMenu == '10-1' ? 'active-menu-item' : '']">
                <Icon type="ios-settings-outline" :color="selectMenu == '10-1' ? '#5bb7ff' : '#ffffff'" class="menu-icon" />
                <div class="sub-menu-text">{{ getTranslation("s336") }}</div>
                </MenuItem>
                <MenuItem name="100-1" :to="{ name: 'doc' }" target="_blank" :class="['menu-item', selectMenu == '100-1' ? 'active-menu-item' : '']">
                <Icon type="ios-help-circle-outline" :color="selectMenu == '100-1' ? '#5bb7ff' : '#ffffff'" class="menu-icon" />
                <div class="sub-menu-text">{{ getTranslation("m215") }}</div>
                </MenuItem>
            </div>
            </MenuItem>
            <MenuItem name="9-1" :to="{ name: 'register' }" v-show="canShow('register.view')" :class="['menu-item', selectMenu == '9-1' ? 'active-menu-item' : '']">
            <Icon type="ios-key-outline" :color="selectMenu == '9-1' ? '#5bb7ff' : '#ffffff'" />
            <div class="menu-text">{{ getTranslation("u085") }}</div>
            </MenuItem>

            <MenuItem name="20-1" :to="{ name: 'register-heron6000_132411' }" v-show="userInfo.register" :class="['menu-item', selectMenu == '20-1' ? 'active-menu-item' : '']">
            <Icon type="ios-key-outline" :color="selectMenu == '20-1' ? '#5bb7ff' : '#ffffff'" />
            <div class="menu-text">{{ getTranslation("e068") }}</div>
            </MenuItem>

            </Col>
            <Col class="info" flex="400px">

            <div class="action-buttons">
                <div class="button-item lang-selector">
                    <div class="version">{{ userInfo.version }}</div>
                    <LangSelect></LangSelect>
                </div>
                <div class="user-info">
                    <label class="user-name">{{ getTranslation('c012') }}{{ userInfo.name }}</label>
                </div>
                <div class="button-item exit-menu">
                    <Button type="text" ghost @click.native="exit()" class="exit-button">
                        <Icon type="md-exit" size="20"></Icon>
                        <div class="button-text">{{ getTranslation('c002') }}</div>
                    </Button>
                </div>
            </div>
            </Col>
        </Row>
    </Menu>
    <Modal v-model="userError" @on-ok="exit" @on-cancel="exit" :okText="getTranslation('b181')" :cancelText="getTranslation('b182')">
        <p>{{ errorMsg }}</p>
    </Modal>
</Header>
</template>

<script>

import {
    API_URL
} from '@/constants/const.js'
import axios from 'axios';
import {
    mapGetters
} from 'vuex'
import {
    postJsError
} from '@/util/util.js'
import LangSelect from './LangSelect.vue'
export default {
    name: 'AppHeader',
    components: { 
        LangSelect
    },
    computed: {
        ...mapGetters(['getTranslation']),
        // highlight "系统" when any child active
        isSystemActive() {
            return this.selectMenu === '6-1' || this.selectMenu === '7-1' || this.selectMenu === '10-1';
        },
        isUserActive() {
            return this.selectMenu === '4-1' || this.selectMenu === '12-1' || this.selectMenu === '8-1';
        },
        isFuncActive() {
            return this.selectMenu === '5-1' || this.selectMenu === '21-1' || this.selectMenu === '22-1' || this.selectMenu === '23-1';
        }
    },
    props: {
        selectMenu: {
            type: String,
            default: '1-1'
        }
    },
    data() {
        return {
            userInfo: {},
            firstChange: true,
            lang: 'zh-cn',

            isReverting: true,
            userError: false,
            errorMsg: '',
            showSystemMenu: false,
            showFuncMenu: false,
            showUserMenu: false,
            enterMainMenu: false,
            enterSubMenu: false,
            closeTimer: null
        }
    },
    created() {
        this.getUserInfo()
    },
    mounted() {
        // removed document click close; hover handles visibility
    },
    beforeDestroy() {
        // ...existing code...
    },
    watch: {
        // remove auto-close on route change to keep dropdown during selection
        selectMenu() {
            this.showSystemMenu = false;
            this.showUserMenu = false;
            this.showFuncMenu = false;
        }
    },
    methods: {
        exit() {
            let url = API_URL["userLogout"];
            axios.get(url)
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.$router.push('/login')
                    } else {
                        this.$Message.error(this.getTranslation('c019'));
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c019'));
                })
        },
        getUserInfo() {
            let _this = this;
            let url = API_URL["userGetInfo"];
            axios.get(url)
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        _this.userInfo = res.data.data;
                        _this.lang = _this.userInfo.lang;
                    } else if (res && res.data && res.data.msg) {
                        //this.errorMsg = res.data.msg;
                        //this.userError = true;
                        this.$router.push('/login')
                    }
                })
                .catch((err) => {
                    postJsError(err)
                })
        },

        // hover handlers
        openSystemMenu(menuItem) {
            this.enterMainMenu = true;
            this.$set(this, menuItem, true);
            this.cancelCloseTimer();
        },
        maybeCloseSystemMenu(menuItem) {
            this.enterMainMenu = false;
            this.cancelCloseTimer();
            if (this.enterSubMenu) {
                return;
            }
            this.$set(this, menuItem, false);

        },

        onDropdownEnter(menuItem) {
            this.enterSubMenu = true;
            this.$set(this, menuItem, true);
            this.cancelCloseTimer();
        },
        onDropdownLeave(menuItem) {
            if (!this.enterMainMenu) {
                this.$set(this, menuItem, false);
            }
            this.enterSubMenu = false;
        },
        cancelCloseTimer() {
            if (this.closeTimer) {
                clearTimeout(this.closeTimer);
                this.closeTimer = null;
            }
        },
        canShow(key) {
            if (!this.userInfo.auth) {
                return false;
            }
            let auth = this.userInfo.auth;
            if (auth === 'all') {
                return true;
            } else {
                return auth.includes(key);
            }
        }
    }
}
</script>

<style>
.menu-row {
    flex-wrap: wrap;
}

.my-menu.ivu-menu-horizontal {
    min-height: 48px;
    height: auto;
    line-height: 48px;
}


</style><style scoped>
@import url('../assets/style/list.css');
.my-menu{
    width: 100%;
}
.layout-nav {
    margin-right: 20px;
}

.logo-container {
    display: flex;
    align-items: center;
    margin-right: 0px;
    padding: 0 5px;
}

.logo {
    height: 20px;
    width: auto;
    max-width: 150px;
}

.menu {
    height: 16px;
    width: auto;
    max-width: 150px;
    margin-top: 2px;
}

.menu-icon {
    font-size: 18px;
    margin-top: 2px;
    margin-right: -2px;
}

.menu-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.menu-item {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 8px 12px;
    position: relative;
    /* allow absolute dropdown */
}

.menu-item:hover {
    background-color: #3B4252;
    color: #5bb7ff;
    border-radius: 8px;
    box-shadow: 0px 0px 20px 0px rgba(91, 183, 255, 0.4);
    background: rgba(59, 66, 82, 255);
    transform: translateY(-2px);
}

.menu-item:hover .menu-text {
    color: #5bb7ff;
}

.sub-menu-item {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    line-height: 14px;
    margin-left: -10px;
}

.dropdown-arrow {
    margin-left: 6px;
    transition: transform 0.2s ease;
}

.dropdown-arrow.open {
    transform: rotate(180deg);
}

.sub-menu-content {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: #3B4252;
    padding: 6px 8px;
    border-radius: 8px;
    box-shadow: 0px 6px 20px rgba(91, 183, 255, 0.2);
    min-width: 160px;
}

/* keep existing hover/active styles working for second-level items */
.sub-menu-content .menu-item {
    color: #fff;
    width: 100%;
    justify-content: flex-start;
    padding: 10px 0;
}

.menu-item .ivu-icon {
    font-size: 18px;

}

.menu-text {
    font-size: 12px;
    line-height: 14px;
    white-space: nowrap;
    margin-left: 5px;
    color: #fff;
}

.sub-menu-text {
    font-size: 12px;
    line-height: 14px;
    white-space: nowrap;
    margin-left: 5px;

}

.icon-menu-text {
    font-size: 12px;
    line-height: 14px;
    white-space: nowrap;
    margin-left: -2px;
}

.sub-menu-content .menu-item:hover {
    cursor: pointer;
    color: #5bb7ff;
    transform: translateY(-2px);
}

.info {
    display: flex;
    justify-content: right;
    align-items: center;
    margin-right: 10px;
}

.user-info {
    margin-right: 4px;
}

.action-buttons {
    display: flex;
    align-items: center;
    gap: 5px;
}

.button-item {
    display: inline-flex;
    align-items: center;
    justify-content: center;

}

.lang-selector {
    flex-direction: row;
    align-items: center;
    height: auto;
}

.exit-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    height: 100%;
}

.exit-button .ivu-icon {
    font-size: 20px;
    margin-bottom: 2px;
}

.button-text {
    margin-top: 2px;
    font-size: 12px;
    line-height: 1.2;
    display: inline;

}

.user-name {
    color: #FFF;
    font-size: 12px;
}

.exit-menu:hover {
    cursor: pointer;
    background-color: #3B4252;
    color: #5bb7ff;
    border-radius: 8px;
    box-shadow: 0px 0px 20px 0px rgba(91, 183, 255, 0.4);
    background: rgba(59, 66, 82, 255);
    transform: translateY(-2px);
}

.button-item:hover {
    cursor: pointer;

}

.sub-menu {
    display: inline-block;
    font-size: 12px;
    margin-top: 4px;
    color: #FFF;
}

.active-menu-item {
    background-color: #3B4252;
    color: #5bb7ff;
    border-radius: 8px;
    box-shadow: 0px 0px 20px 0px rgba(91, 183, 255, 0.4);
    background: rgba(59, 66, 82, 255);
}

.active-menu-item .menu-text {
    color: #5bb7ff;
}

.version {
    font-size: 12px;
    color: #fff;
    margin-right: 10px;
}
</style>
